import { Autocomplete, CircularProgress, TextField } from '@mui/material';
import { useController } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { Brands } from 'shared/types';

interface QueryResponse {
  types: string[] | undefined;
  isFetching: boolean;
  isLoading: boolean;
}
interface ProductTypeDropdownProps {
  name: `${string}` | `${string}.${string}` | `${string}.${number}`;
  label: string;
  defaultValue: string;
  readOnly?: boolean;
  errorMessage: string;
  useQuery: (brand: Brands) => QueryResponse;
  error?: boolean;
  helperText?: string;
}
export function ProductDropdown({
  name,
  error,
  errorMessage,
  useQuery,
  label,
  helperText,
  defaultValue,
  readOnly,
}: ProductTypeDropdownProps) {
  const { brand } = useParams<{ brand: Brands }>();
  const {
    field: { onChange, value },
  } = useController({
    name,
    rules: { required: { message: errorMessage, value: true } },
    defaultValue: defaultValue || '',
  });
  const { types, isFetching, isLoading } = useQuery(brand);

  const loading = isFetching || isLoading;

  return (
    <Autocomplete
      id={name}
      onChange={(_, value) => {
        onChange(value);
      }}
      autoHighlight
      selectOnFocus
      clearOnBlur
      isOptionEqualToValue={(option, value) => {
        if (!option || !value) {
          return true;
        }
        return option === value;
      }}
      options={types || []}
      value={value}
      getOptionLabel={option => option}
      fullWidth
      loading={loading}
      disabled={readOnly || false}
      renderInput={params => (
        <TextField
          {...params}
          label={label}
          variant='outlined'
          error={error}
          helperText={helperText}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading && <CircularProgress color='inherit' size={20} />}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
}
